module.exports = __webpack_public_path__ + "img/icon_sm_ckcb.f54f2543.png";